import React from 'react';
import { Box, Collapse, IconButton, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';
import {
  headerContainerSx,
  collapseContainerSx,
  filterBarOuterSx,
  filterBarInnerSx,
  collapseToggleSx,
} from '../../../styles';

/**
 * FilterBar - A collapsible container for filter sections
 *
 * @param {boolean} open - Whether the filter bar is expanded
 * @param {function} onToggle - Callback when collapse toggle is clicked
 * @param {number} maxWidth - Maximum width of the filter bar (default 1350)
 * @param {React.ReactNode} children - FilterBar.Section components
 */
function FilterBar({ open, onToggle, maxWidth = 1350, children }) {
  const theme = useTheme();

  return (
    <Box sx={headerContainerSx(theme)} elevation={0}>
      <Collapse in={open} sx={collapseContainerSx}>
        <Box sx={filterBarOuterSx}>
          <Box elevation={0} sx={filterBarInnerSx}>
            <Box
              sx={{
                display: 'flex',
                width: `${maxWidth}px`,
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'center',
              }}
            >
              {children}
            </Box>

            {/* Collapse toggle - only visible when expanded */}
            <Tooltip title="Collapse filters">
              <IconButton
                sx={collapseToggleSx}
                onClick={onToggle}
                aria-label="Collapse filters"
              >
                <ExpandMoreIcon sx={{ transform: 'rotate(180deg)' }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}

export default FilterBar;
